// extracted by mini-css-extract-plugin
export var root = "BlogPreview-module--root--e7023";
export var blogPreviewImage = "BlogPreview-module--blogPreviewImage--3dd51";
export var category = "BlogPreview-module--category--ad951";
export var link = "BlogPreview-module--link--7ef3b";
export var title = "BlogPreview-module--title--67522";
export var excerpt = "BlogPreview-module--excerpt--be3c5";
export var hideReadMoreOnWeb = "BlogPreview-module--hideReadMoreOnWeb--16bdb";